import React from 'react'
import { CollateralIdentifierType } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { getEnumValues, CollateralIdentifierTypeHelper } from 'model'

export type CollateralIdentifierTypeSelectboxProps = Omit<SelectboxProps<CollateralIdentifierType, CollateralIdentifierType>, 'optionKeys'>

const PrimaryCollateralIdentifierTypes = [CollateralIdentifierType.ISIN, CollateralIdentifierType.CUSIP]

export const CollateralIdentifierTypeSelectbox = React.forwardRef(
  (props: CollateralIdentifierTypeSelectboxProps, ref: React.Ref<Selectbox>) => {
    const optionKeys = getEnumValues(CollateralIdentifierType).filter(collateralIdentifierType =>
      PrimaryCollateralIdentifierTypes.includes(collateralIdentifierType)
    )
    return <Selectbox ref={ref} optionKeys={optionKeys} getOptionText={CollateralIdentifierTypeHelper.getName} {...props} />
  }
)

export const CollateralIdentifierTypeSelectboxField = Field(CollateralIdentifierTypeSelectbox)
